import React from "react";
import AdmClassTimeTable from "../../components/AdminTabs/AdminClassTimeTable/AdmClassTimeTable";

const DayBook = () => {
  return (
    <div>
      <AdmClassTimeTable />
    </div>
  );
};

export default DayBook;
